<template>
    <div>
       <div class="modal fade" id="localOneCodePerMemberModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="couponCodeContainer">
            <div class="modal-dialog coupon-modal-local" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <img src="/assets/images/famkort-y.svg" style="width:100%;margin-top:1.5em;" alt="Familjekortet logga">

                    <div class="logo-rounded-modal-local mt-0">
                        <div>
                            <img :src="companyImages.company_logo_image" :alt="`${company.name} Logga`">
                        </div>
                    </div>

                    <p class="discount-text">{{ $filters.truncate(campaign.heading, 300, '') }}</p>

                    <input class="code-view-local" type="text" :disabled="true" v-if="couponCode !== null" :value="couponCode" />

                    <div v-if="campaign.end_date" class="offer white small mt-2 text-center">
                        <p class="m-0"><span class="text-bold" >{{ $t('limited_time_offer') }}</span></p>
                        <p><span>{{ $t('valid_until') }} {{formatDate(campaign.end_date)}}</span></p>
                    </div>

                    <div class="offer small white text-center">
                        <p><span>*Aktiverad kod är giltig i <b>24 timmar</b></span></p>
                    </div>

                </div>
            </div>
        </div>

        <coupon-code-expired-modal></coupon-code-expired-modal>
        <server-error-modal></server-error-modal>
    </div>
</template>

<script>
    import CouponModalHelpers from '@/mixins/CouponModalHelpers';

    export default {
        mixins: [CouponModalHelpers],

        methods: {
            start () {
                this.claimCouponCode();
            },

            claimCouponCode () {
                axios.get('/api/site/campaign/claimcode/' + this.campaign.id).then(response => {
                    this.couponCode = response.data.data;
                    $('#localOneCodePerMemberModal').modal('show');
                    // this.$gtag.pageview(window.location.pathname + '#showCouponCode');
                }).catch(error => {
                    this.handleClaimCouponCodeError(error);
                });
            }
        }
    }
</script>
